import { Bell } from "lucide-react";
import { useTranslation } from "react-i18next";
import { setNotificationSounds } from "../../lib/notification-sounds";
import { useNotificationSounds } from "../../lib/use-notification-sounds";
import { DropdownMenuCheckboxItem } from "../ui/dropdown-menu";

export function NotificationSoundsItem() {
  const { t } = useTranslation();
  const enabled = useNotificationSounds();
  return (
    <DropdownMenuCheckboxItem
      checked={enabled}
      onCheckedChange={(checked) => setNotificationSounds(checked === true)}
      onSelect={(event) => event.preventDefault()}
    >
      <Bell aria-hidden="true" />
      {t("auth.notificationSounds")}
    </DropdownMenuCheckboxItem>
  );
}
